// This file contains text constants used in several modules across the application.
// Add text constants that are meant to be used in multiple modules here.
// For example, cross-sell text constants, common text or error messages, etc.

// Luxury Promotions marketting / awareness
export const COMPLIMENTARY_NIGHT_PROMOTION_TITLE = "Complimentary fourth night";
export const COMPLIMENTARY_NIGHT_PROMOTION_DESCRIPTION =
  "Extend your escape when you book an eligible stay of at least four nights at select Premier and Lifestyle Collection Hotels.";
export const COMPLIMENTARY_NIGHT_PROMOTION_BUTTON_TEXT = "Explore properties";
